import React, { useEffect, useState } from 'react';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { UserSession } from 'types';
import { dispatchSideMenuToggle } from 'store/dispatcher';
import ParagraphText from 'components/Elements/ParagraphText/ParagraphText';
import styled from 'styled-components';
import { COLOR_BLACK, COLOR_SECONDARY } from 'constants/colors';
import UserProfile from 'components/Cards/UserProfile';
import { getSideMenuStatus } from 'store/slices/sideMenuSlice';
import DropdownMenu, {
  DropdownItem,
} from 'components/Elements/Dropdown/Dropdown';
import useLogout from 'hooks/useLogout';
import useIsMobile from 'hooks/useIsMobile';
import { useAppSelector } from '../../store/hooks';

const StyledContainer = styled.div`
  display: flex;
  position: fixed !important;
  background-color: ${COLOR_BLACK};
  align-items: center;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 999;
  height: 4.75rem;
  padding: 1.25rem;
  margin: 0 auto;
  box-shadow: 0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1);
  border-bottom: solid 1px #fff;
`;

const BrandContainer = styled.div`
  order: 0;
  @media (min-width: 992px) {
    order: 1;
  }
`;

const BrandLink = styled(NavLink)`
  display: flex;
  align-items: center;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

const StyledDropdown = styled(DropdownMenu)`
  display: none;
  order: 2;
  margin-right: 10px;
  margin-left: auto;
  @media (min-width: 992px) {
    display: block;
  }
`;

interface BurgerProps {
  sideMenuIsOpen: boolean;
}

const Burger = styled.button<BurgerProps>`
  background-color: transparent;
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: auto;
  margin-right: 0;
  text-align: center;
  margin-top: 0px;
  order: 3;

  svg {
    color: ${props => (props.sideMenuIsOpen ? COLOR_SECONDARY : '#fff')};
    width: 25px !important;
    height: 35px;
    margin: auto;
  }

  @media (min-width: 992px) {
    margin-right: 15px;
    margin-left: 0;
    order: 0;
  }
`;

interface NavBarProps {
  user: UserSession;
}
/**
 * Renders navigation menu.
 * @param param0
 * @returns
 */
export default function NavBar({ user }: NavBarProps) {
  const sideMenuIsOpen = useAppSelector(getSideMenuStatus);
  const [links, setLinks] = useState<DropdownItem[]>([]);

  const { logout } = useLogout();

  const { isMobile } = useIsMobile();

  useEffect(() => {
    const navBarLinks: DropdownItem[] = [
      {
        label: 'Logout',
        onClick: logout,
      },
    ];

    setLinks(navBarLinks);
  }, []);

  return (
    <StyledContainer>
      <BrandContainer>
        <BrandLink end to="/">
          <ParagraphText fontSize={24} marginRight={2} color="#fff">
            SCLA 2024
          </ParagraphText>
        </BrandLink>
      </BrandContainer>

      <Burger
        sideMenuIsOpen={sideMenuIsOpen}
        onClick={dispatchSideMenuToggle}
      >
        <FontAwesomeIcon color="#fff" icon={faBars} />
      </Burger>

      {!isMobile && (
        <StyledDropdown
          toggleElement={<UserProfile user={user} />}
          items={links}
        />
      )}
    </StyledContainer>
  );
}
